// extracted by mini-css-extract-plugin
export default {"footerSignup":"ForgotPasswordPage_footerSignup__xq2zK"};